import { render, staticRenderFns } from "./placeorder.vue?vue&type=template&id=76481a1a&scoped=true&"
import script from "./placeorder.vue?vue&type=script&lang=js&"
export * from "./placeorder.vue?vue&type=script&lang=js&"
import style0 from "./placeorder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./placeorder.vue?vue&type=style&index=1&id=76481a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76481a1a",
  null
  
)

export default component.exports